import { createAsyncAction, createAction } from 'redux-promise-middleware-actions';
import { addAsyncActionPostfixes } from '../utils/actionTypeCreator';
import api, { identityAxiosClient } from '../api/apiSettings';
import { encryptPassword } from '../utils/encryptPassword';

export const SUCCESS_MESSAGE = 'Success!';

export const types = {
  ...addAsyncActionPostfixes({
    VALIDATE_DIRECT_INVITE: 'VALIDATE_DIRECT_INVITE',
    CHANGE_DIRECT_INVITE_PASSWORD: 'CHANGE_DIRECT_INVITE_PASSWORD'
  }),
  RESET_PASSWORD_SETUP: 'RESET_PASSWORD_SETUP'
};

const isSuccess = (data) => data?.Data?.Message === SUCCESS_MESSAGE || data?.Message === SUCCESS_MESSAGE;

// Resolves to true when the contractor still has to set their password
export const validateDirectInvite = createAsyncAction(types.VALIDATE_DIRECT_INVITE, (email) =>
  api.post('v1/validate-direct-invite-magic-link', { Email: email }).then((res) => isSuccess(res.data))
);

export const changeDirectInvitePassword = createAsyncAction(types.CHANGE_DIRECT_INVITE_PASSWORD, (email, password) =>
  identityAxiosClient
    .post('ChangeDirectInvitePassword', { Email: email, Password: encryptPassword(password) })
    .then((res) => res.data)
);

export const resetPasswordSetup = createAction(types.RESET_PASSWORD_SETUP);
